import './VisualEditorTest.scss';
import { useContext, useEffect, useRef, useState, } from "react";
import DebugLogger from "../../helpers/DebugLogger";
import { IconJsxer } from "../../helpers/IconHelper";
import axios from "../../api/axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { CampaignContext } from "../../contexts/CampaignContext";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import { AuthContext } from "../../contexts/AuthContext";
import { getCampaignCustomisationVarsRoute, getCampaignOverviewRoute } from "../../api/routes";
import NodeList, { NODE_LIST_CONTROLLER, NODE_LIST_DRAG_MODES } from "../../components/NodeList/NodeList";
import { CUSTOMISED_URL_MAP, getValFromObject } from "../../config/FeatureDashboardVarMap";
import { getFeatureAssetBaseUrl } from "../../helpers/FeatureAssets";
import CustomisationControls from "../../components/CustomisationControls/CustomisationControls";
import { DEFAULT_RIGHT_CLICK_MENU, RIGHT_CLICK_MENU_CONTROLLER } from "../../components/RightClickMenu/RightClickMenu";
import { FEATURE_CONTROLS_TYPES } from "../../helpers/FeatureControlsHelper";
import { addCustomFieldButton, BLANK_STRUCTURES, CUSTOMISATION_MODULES, ENUM_LISTS, exportFeatureConfigJsonFileDataFromNodeListData, getInitialNewFormatData, processNodesToFinalDataObject, RenderNodeName, updateNodeListData } from "../../helpers/devBuildTools/TimelineBuilder";
import CustomisationWorkspaceMain from "../../components/v2/CustomisationWorkspace/CustomisationWorkspaceMain";
import { AutoDiscoverNodeLinks } from "../../helpers/devBuildTools/AutoDiscoveryFunctions";

const VisualEditorTest = (props) => {
    const { campaignId } = useParams();
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    const [authContext, setAuthContext] = useContext(AuthContext);
    const navigate = useNavigate();

    const campaignData = campaignContext.campaignData;

    const [orderedFeatureData, setOrderedFeatureData] = useState(null);
    // Make sure all our features have a stacking order assigned.
    // Not worried about saving this until we make changes because I'll do the same check on the feature page.
    const verifyStacking = (campaignData) => {
        console.log('Verify stacking order (before): ', JSON.parse(JSON.stringify(campaignData.features)));
        let highestStack = 0;
        for (let i = 0; i < campaignData.features.length; i++) {
            if (typeof campaignData.features[i].stackingOrder !== 'undefined' && campaignData.features[i].stackingOrder > highestStack) {
                highestStack = campaignData.features[i].stackingOrder;
            }
        }
        for (let i = 0; i < campaignData.features.length; i++) {
            if (typeof campaignData.features[i].stackingOrder === 'undefined') {
                highestStack++;
                campaignData.features[i].stackingOrder = highestStack;
                console.log('Verify stacking order (set stack) Feature: ', campaignData.features[i].contentLabel, ' - Stacking Order: ', highestStack);
            }
        }
        console.log('Verify stacking order (after): ', JSON.parse(JSON.stringify(campaignData.features)));
    }

    /** Make sure we have campiagn data - as this is it's own route we can't guarantee we do! */
    const pullInCampaignData = (pullInCustomisation = true, callback = null) => {
        if (campaignId) {
            axios
                .get(getCampaignOverviewRoute, { params: { campaignID: campaignId }, withCredentials: true })
                .then((response) => {
                    console.log('Got campaign data: ', response.data.campaignData);
                    /* if (pullInCustomisation) {
                        buildTabs(response.data.campaignData);
                        determineIfThemeable(response.data.campaignData);
                    } */
                    verifyStacking(response.data.campaignData);

                    const orderedFeatures = [...response.data.campaignData.features];
                    orderedFeatures.sort((a, b) => b.stackingOrder - a.stackingOrder);
                    setOrderedFeatureData(orderedFeatures);
                    console.log("Ordered feature data: ", orderedFeatures);

                    // buildTopLevelNodes(orderedFeatures, response.data.campaignData);

                    setCampaignContext((oldValues) => {
                        return { ...oldValues, initialising: false, campaignData: response.data.campaignData }
                    })

                    getCustomisationVars(response.data.campaignData);
                    /* if (pullInCustomisation) {
                        getCustomisationVars(response.data.campaignData);
                    }
                    if (callback) {
                        callback(true, response);
                    }
                    if (response.data.campaignData.features.length) {
                        let needQuizData = false;
                        for (let i = 0; i < response.data.campaignData.features.length; i++) {
                            // If we are deiting a quiz we need to have quiz data available
                            if (response.data.campaignData.features[i]._id === featureId && response.data.campaignData.features[i].varKey === 'quizPoll') {
                                needQuizData = true;
                                break;
                            }
                        }
                        if (needQuizData) {
                            getCampaignQuizzes();
                            getGenericQuizzes();
                        }
                    } */
                })
                .catch((error) => {
                    toast.error("Error fetching campaign data");
                    if (!callback) {
                        navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
                    }
                });
        } else {
            if (!callback) {
                navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
            }
        }
    }

    const findFeatureData = (campaignData, featureId) => {
        // console.log('Finding feature data from campaign data: ', campaignData);
        if (campaignData && campaignData.features) {
            for (let i = 0; i < campaignData.features.length; i++) {
                if (campaignData.features[i]._id === featureId) {
                    return campaignData.features[i];
                }
            }
        }
        return null;
    }

    const fixSrcUrls = (featureData, featureId, customisationDataIn = null, dataToFix = null) => {
        const customisationData = customisationDataIn || featureData.feature.customisation;
        // console.log('FIX URL', featureData, customisationData, dataToFix);
        for (let i = 0; i < customisationData.length; i++) {
            // console.log('i loop: ', i, customisationData[i], customisationVarsRef.current, featureId);
            const rootVal = dataToFix ?? customisationVarsRef.current.current[featureId];
            const tabKey = customisationData[i].tabKey;
            // console.log('rootVal, tabKey: ', rootVal, tabKey);
            // console.log('-----');
            for (let j = 0; j < customisationData[i].options.length; j++) {
                // console.log('j loop: ', j);
                const varKey = customisationData[i].options[j].varKey;
                // console.log('varKey: ', varKey);
                // console.log('-----');
                for (let k = 0; k < customisationData[i].options[j].variables.length; k++) {
                    // console.log('k loop: ', k);
                    const varName = customisationData[i].options[j].variables[k].varName;
                    // console.log('varName: ', varName);
                    // console.log('-----');
                    for (let prop in customisationData[i].options[j].variables[k].valSchema) {
                        // console.log('prop loop: ', prop);
                        const type = customisationData[i].options[j].variables[k].valSchema[prop].type.toLowerCase();
                        // console.log('type: ', type);
                        // console.log('-----');
                        if (CUSTOMISED_URL_MAP.hasOwnProperty(type)) {
                            // console.log('We need to generate a Url here!');
                            // We found one we need to map to a url!
                            const vals = getValFromObject(rootVal[tabKey], varKey, varName);
                            // console.log('vals: ', vals);
                            // console.log('-----');
                            if (vals && vals.length) {
                                for (let l = 0; l < vals.length; l++) {
                                    // console.log('vals loop: ', l);

                                    // Reformat legacy string based filenames to be objects...
                                    // SrcUrl has to be part of the object, meaning all feature customisations are going to break...
                                    let filename = vals[l][prop];
                                    if (typeof filename === 'string' || typeof filename === 'undefined' || filename === null) {
                                        filename = { filename: vals[l][prop] };
                                        vals[l][prop] = filename;
                                        filename.isDefault = vals[l].isDefault;
                                    }

                                    // console.log('Filename: ', filename);
                                    if (filename.srcUrl && typeof filename.srcUrl === 'string' && filename.srcUrl.startsWith('blob:')) {
                                        // Do nothing...
                                    } else {
                                        const srcUrl = (typeof filename.filename === 'undefined' || filename.filename === null || filename.filename === '') ? null :

                                            (filename.isDefault ? getFeatureAssetBaseUrl(true) + featureData.feature.defaultAssetFolder : getFeatureAssetBaseUrl(false)
                                                + 'campaigns/' + (campaignId || campaignContext.campaignData._id)
                                                + '/' + (featureId /* + (streamId && vals[l][prop].isStreamLevel ? ('/' + streamId) : '') */))
                                            + '/' + CUSTOMISED_URL_MAP[type].dir
                                            + '/' + (filename.isDefault ? filename.filename : filename.filename.replace(/(?:\.(?![^.]+$)|[^\w.])+/g, ""));

                                        // console.log('srcUrl: ', srcUrl);
                                        filename.srcUrl = srcUrl;
                                    }
                                    filename.originalFile = filename.originalFile || filename.filename;
                                    filename.type = CUSTOMISED_URL_MAP[type].dir;
                                    // console.log( filename.srcUrl);
                                }
                            }

                            // console.log('Urls generated for: ', vals);
                        }
                    }
                }
            }
        }
    }

    const [customisationVars, setCustomisationVars] = useState({});
    const customisationVarsRef = useRef(null);
    const [customisationVarsFetched, setCustomisationVarsFetched] = useState(false);
    const getCustomisationVars = (campaignData, updateThisIdOnly = null) => {
        console.log('Get Campaign / Stream Customisation Vars', campaignId, updateThisIdOnly);
        axios
            .get(/* streamId ? getStreamCustomisationVarsRoute :  */getCampaignCustomisationVarsRoute, {
                params: { campaignID: campaignId, streamID: null/*streamId*/ },
                withCredentials: true
            })
            .then(function (response) {
                console.log('CAMPAIGN CUSTOMISATION VARS',response.data);
                if (response.data.customisationVars) {
                    if (updateThisIdOnly) {
                        // console.log('Got customisation vars to update Id: ', updateThisIdOnly, response.data.customisationVars);
                        customisationVarsRef.current.current[updateThisIdOnly] = response.data.customisationVars.current[updateThisIdOnly];
                        customisationVarsRef.current.default[updateThisIdOnly] = response.data.customisationVars.default[updateThisIdOnly];
                    } else {
                        customisationVarsRef.current = response.data.customisationVars;

                        if (updateThisIdOnly) {
                            // convert any filenames into urls and remember the original filenames as well while we are at it (so we can delete old files afterwards)
                            // console.log('Generate urls ------>>> ', campaignData)
                            const featureData = findFeatureData(campaignData, updateThisIdOnly);
                            // console.log('Feature data: ', featureData);
                            // const customisationData = featureData.feature.customisation;
                            // console.log('Customisation data: ', customisationData);
                            // console.log('-----');

                            fixSrcUrls(featureData, updateThisIdOnly);
                        } else {
                            // Step through all the features and fix the srcUrls for each one
                            console.log('Generate urls for all features');
                            for (let i = 0; i < campaignData.features.length; i++) {
                                const featureData = findFeatureData(campaignData, campaignData.features[i]._id);
                                // console.log('Feature data: ', featureData);
                                fixSrcUrls(featureData, featureData._id);
                            }
                        }

                        setCustomisationVars(customisationVarsRef.current);
                        setCustomisationVarsFetched(true);
                        console.log('Got customisation vars: ', customisationVarsRef.current);
                    }
                }
            })
            .catch(function (error) {
                toast.error('Error - ' + error);
                // console.log(error.response)
            });
    }

    useEffect(() => {
        setCampaignContext((oldValues) => {
            return { ...oldValues, initialising: true }
        });
        pullInCampaignData();
        /* while (prevFeatures.current[prevFeatures.currentlength - 1] === featureId) {
            prevFeatures.current.pop();
        }
        setShowCleaningUp(false);
        setShowUploadProgress(false);
        setShowingAddTheme(false);
        setShowingEditTheme(false);
        setShowingDeletingTheme(false);
        setShowCommonFontPopup(false); */
    }, [campaignId]);

    return (
        <div className="content-page-container customise-campaign-holder">
            {campaignData && campaignData._id && campaignData.features && campaignData.features.length > 0 && customisationVars && customisationVarsFetched &&
                <div className="workspace-preview-holder">
                    <div className="workspace-preview">
                        <CustomisationWorkspaceMain
                            campaignId={campaignId}
                            campaignData={campaignData}
                            customisationVars={customisationVars}
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default VisualEditorTest;
